import CourseAvailableContainer from './CourseAvailableContainer';

export default CourseAvailableContainer;